export default "__VITE_ASSET__Dgybwlxt__"